import React, { useEffect } from 'react';
import {
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  Select,
  Textarea,
  Badge,
  FormErrorMessage
} from '@chakra-ui/react';
import { useNewKBLeadForm } from '../context/NewKBLeadFormContext';

const NewKBProposalForm = () => {
  // Use the form context for state management
  const { 
    formData, 
    handleFormChange,
    errors
  } = useNewKBLeadForm();

  // Ensure proposal object exists
  const proposal = formData.proposal || { status: 'pending', details: '' };
  
  // Log initial values for debugging
  useEffect(() => {
    console.log('[NewKBProposalForm] Initial Proposal Form Values:', proposal);
  }, []);

  // Determine status color for the badge
  const getStatusColor = (status) => {
    switch (status) {
      case 'sent':
        return 'blue';
      case 'accepted':
        return 'green';
      case 'rejected':
        return 'red';
      default:
        return 'gray';
    }
  };

  // Handle proposal field changes
  const handleProposalChange = (field, value) => {
    console.log(`[NewKBProposalForm] Updating ${field}:`, value);
    
    // Update the proposal object with the new value
    const updatedProposal = {
      ...proposal,
      [field]: value
    };
    
    // Update the form data
    handleFormChange('proposal', updatedProposal);
  };
  
  return (
    <Grid templateColumns="repeat(2, 1fr)" gap={6}>
      <GridItem colSpan={2}>
        <FormControl>
          <FormLabel>Current Status</FormLabel>
          <Badge colorScheme={getStatusColor(proposal.status)} mb={2} fontSize="md" p={1}>
            {proposal.status || 'pending'}
          </Badge>
        </FormControl>
      </GridItem>

      <GridItem colSpan={2}>
        <FormControl isInvalid={errors?.proposal?.status}>
          <FormLabel>Update Status</FormLabel>
          <Select 
            value={proposal.status || 'pending'}
            onChange={(e) => {
              handleProposalChange('status', e.target.value);
            }}
          >
            <option value="pending">Pending</option>
            <option value="sent">Sent</option>
            <option value="accepted">Accepted</option>
            <option value="rejected">Rejected</option>
          </Select>
          {errors?.proposal?.status && (
            <FormErrorMessage>{errors.proposal.status}</FormErrorMessage>
          )}
        </FormControl>
      </GridItem>

      <GridItem colSpan={2}>
        <FormControl isInvalid={errors?.proposal?.details}>
          <FormLabel>Proposal Details</FormLabel>
          <Textarea
            value={proposal.details || ''}
            onChange={(e) => handleProposalChange('details', e.target.value)}
            placeholder="Enter proposal details..."
            rows={6}
            resize="vertical"
          />
          {errors?.proposal?.details && (
            <FormErrorMessage>{errors.proposal.details}</FormErrorMessage>
          )}
        </FormControl>
      </GridItem>
    </Grid>
  );
};

export default NewKBProposalForm;
